import { IAchOutLimits } from '../hooks/query/useGetAchOutLimits';

export const getLowestLimit = (achLimits: IAchOutLimits) => {
  const sortingArray: any = [];
  Object.keys(achLimits).forEach((key) => {
    sortingArray.push({ key, value: achLimits[key] });
  });
  sortingArray.sort((a: {key: string, value: number}, b: {key: string, value: number}) => a.value - b.value);
  return sortingArray[0];
};
